import * as globals from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const Wrapper = styled.div`
  .icon {
    font-size: 20px;
    color: ${globals.gray800};
  }
`;
Wrapper.displayName = 'S.Wrapper';

export const HighlightedIcon = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
HighlightedIcon.displayName = 'S.HighlightedIcon';
